import defaultConfig from '@crema/constants/defaultConfig';
import PropTypes from 'prop-types';
import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';

const LayoutContext = createContext();
const LayoutActionsContext = createContext();

export const useLayoutContext = () => useContext(LayoutContext);

export const useLayoutActionsContext = () => useContext(LayoutActionsContext);

const LayoutContextProvider = ({ children }) => {
    const [layoutType, setLayoutType] = useState(defaultConfig.layoutType);
    const [navStyle, setNavStyle] = useState(defaultConfig.navStyle);
    const [footerType, setFooterType] = useState(defaultConfig.footerType);
    const [footer, setFooter] = useState(defaultConfig.footer);
    const [headerType, setHeaderType] = useState(defaultConfig.headerType);

    const updateNavStyle = useCallback((navStyle) => {
        setNavStyle(navStyle);
    }, []);

    const values = useMemo(
        () => ({
            navStyle,
            footerType,
            footer,
            layoutType,
            headerType,
        }),
        [navStyle, footerType, footer, layoutType, headerType],
    );

    const actions = useMemo(
        () => ({
            setFooter,
            setFooterType,
            updateNavStyle,
            setLayoutType,
            setHeaderType,
        }),
        [
            setFooter,
            setFooterType,
            updateNavStyle,
            setLayoutType,
            setHeaderType,
        ],
    );

    return (
        <LayoutContext.Provider value={values}>
            <LayoutActionsContext.Provider value={actions}>
                {children}
            </LayoutActionsContext.Provider>
        </LayoutContext.Provider>
    );
};

export default LayoutContextProvider;

LayoutContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
